import {
  faBars,
  faClipboard,
  faClipboardList,
  faDatabase,
  faPeopleGroup,
  faUser,
  faUsers,
  faUserClock,
  faSliders,
  faRobot, 
  faGraduationCap
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import { NavLink } from 'react-router-dom';
import './sideBarNavigation.css';

const switchNavStyle = ({ isActive }) => (isActive ? 'nav-link active' : 'nav-link');

const SideBarNav = () => {
  const [contentHeight, setContentHeight] = useState();

  useEffect(() => {
    window.addEventListener('resize', updateWidthAndHeight);
    return () => window.removeEventListener('resize', updateWidthAndHeight);
  });

  const updateWidthAndHeight = () => {
    const body = document.body;
    const html = document.documentElement;
    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    setContentHeight(document.body.clientHeight);
  };
  return (
    <Container className="sidebarContainer">
      <Nav className="flex-column sideNav" style={{ height: contentHeight }}>
        <Nav.Link href="/home">
          <FontAwesomeIcon icon={faBars} size="sm" /> <span>Dashboard</span>
        </Nav.Link>
        <Nav.Link eventkey="link-1">
          <FontAwesomeIcon icon={faPeopleGroup} size="sm" />
          <span>Team</span>
        </Nav.Link>
        <Nav.Link eventkey="link-2">
          <FontAwesomeIcon icon={faDatabase} size="sm" />
          <span>My Data Base</span>
        </Nav.Link>
        <NavLink className={switchNavStyle} to="/candidates" eventkey="link-3">
          <FontAwesomeIcon icon={faUser} size="sm" />
          <span>Candidates</span>
        </NavLink>
        <NavLink className={switchNavStyle} to="/unapproved-candidates" eventkey="link-3">
          <FontAwesomeIcon icon={faUserClock} size="sm" />
          <span>Approval Requested Candidates</span>
        </NavLink>
        <NavLink className={switchNavStyle} to="/users" eventkey="link-3">
          <FontAwesomeIcon icon={faUser} size="sm" />
          <span>User Management</span>
        </NavLink>
        <NavLink className={switchNavStyle} to="/candidate-assignment" eventkey="link-3">
          <FontAwesomeIcon icon={faUser} size="sm" />
          <span>Candidate Assignments</span>
        </NavLink>
        <NavLink className={switchNavStyle} to="/assigned-candidates" eventKey="link-7">
          <FontAwesomeIcon icon={faUsers} size="sm" />
          <span>Assigned Candidates</span>
        </NavLink>
        <NavLink className={switchNavStyle} to="/self-registered-candidates" eventKey="link-8">
          <FontAwesomeIcon icon={faUserClock} size="sm" />
          <span>Self Registered Candidates</span>
        </NavLink>
        <NavLink className={switchNavStyle} to="/clients" eventkey="link-3">
          <FontAwesomeIcon icon={faUser} size="sm" />
          <span>Clients</span>
        </NavLink>
        <NavLink className={switchNavStyle} to="/master-data" eventkey="link-3">
          <FontAwesomeIcon icon={faSliders} size="sm" />
          <span>Master Data</span>
          </NavLink>
        <NavLink className={switchNavStyle} to="/ai-interviews" eventkey="link-ai">
          <FontAwesomeIcon icon={faRobot} size="sm" />
          <span>AI Interviews</span>
        </NavLink>
        <NavLink className={switchNavStyle} to="/job-notification-batches" eventkey="link-job-notification">
          <FontAwesomeIcon icon={faClipboardList} size="sm" />
          <span>Job Notifications</span>
        </NavLink>

        <NavLink
          className={switchNavStyle}a
          to="/career-guidance"
        >
          <FontAwesomeIcon icon={faGraduationCap} size="sm" />
          <span>Career Guidance</span>
        </NavLink>
        
        <Nav.Link eventkey="link-4">
          <FontAwesomeIcon icon={faClipboardList} size="sm" />
          <span>Audit Trail</span>
        </Nav.Link>
        <Nav.Link eventkey="link-5">
          <FontAwesomeIcon icon={faClipboard} size="sm" />
          <span>Reports</span>
        </Nav.Link>
        <Nav.Link to="/bulk-resume-upload" eventkey="link-6">
          <FontAwesomeIcon icon={faClipboard} size="sm" />
          <span>Bulk Resume Upload</span>
        </Nav.Link>
      </Nav>
    </Container>
  );
};

export default SideBarNav;